import { createTheme } from '@mui/material/styles';
import { frFR } from '@mui/x-data-grid';
import { frFR as coreFrFR } from '@mui/material/locale';
import { colorDarkWhite, colorPrimary } from './color';


// declare module '@mui/material/styles' {


export const theme = createTheme(
  {
    palette: {
      primary: {
        main: colorPrimary,        // #3b82f6 — bleu
        light: colorDarkWhite,
        contrastText: '#ffffff',
      },
      secondary: {
        main: '#ffffff',
        // main: '#f5f5f5',
      },
      tertiary: {
        main: '#1e293b',
        contrastText: colorDarkWhite,
      }
    },
    components: {
      MuiDialog: {
        styleOverrides: {
          root: {
            '& .MuiBackdrop-root': {
              backgroundColor: 'rgba(15, 23, 42, 0.15)',
            },
          },
          paper: {
            borderRadius: 20,
            backgroundColor: 'rgba(255, 255, 255, 0.55)',
            backdropFilter: 'blur(24px)',
            WebkitBackdropFilter: 'blur(24px)',
            boxShadow: '0 24px 48px rgba(0,0,0,0.08)',
            border: '1px solid rgba(255,255,255,0.5)',
          },
        },
      },
      MuiModal: {
        styleOverrides: {
          root: {
            '& .MuiBackdrop-root': {
              backgroundColor: 'rgba(15, 23, 42, 0.15)',
            },
          },
        },
      },
    },
  },
  frFR,
  coreFrFR
);
